import LeftNavPanel from './LeftNavPanel';

/** The Dashboard UI for all Experteers, mimicking the original legacy application's similar page.
 * In the future this will be reworked to include similar view for org representatives. */
const Dashboard = ({ children }: { children: React.ReactElement }) => {
  return (
    /* TODO: Likely relocate this as we learn more about the new layout
     * styles and whether this bkg color should apply app-wide */
    <div className='bg-gray-25'>
      <div className='flex flex-col sm:flex-row max-w-[1440px] mx-auto '>
        <div className='hidden md:block'>
          <LeftNavPanel />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Dashboard;
